/** Set when someone signs in as an operator, or via ?abTestMenu=true, so the AB test menu is still reachable once they log out */
const AB_TEST_MENU_KEY = 'showAbTestMenu';

/** ?abTestMenu=true turns the menu on without an operator login, ?abTestMenu=false turns it back off */
const AB_TEST_MENU_QUERY_PARAM = 'abTestMenu';

export const hasAbTestMenuFlag = () => {
  try {
    return localStorage.getItem(AB_TEST_MENU_KEY) === 'true';
  } catch {
    return false;
  }
};

export const setAbTestMenuFlag = () => {
  try {
    localStorage.setItem(AB_TEST_MENU_KEY, 'true');
  } catch {
    // Private browsing can block writes, in which case the menu just will not persist
  }
};

export const clearAbTestMenuFlag = () => {
  try {
    localStorage.removeItem(AB_TEST_MENU_KEY);
  } catch {
    // Nothing to do, the flag was never stored
  }
};

/** undefined when the parameter is absent, so the stored flag is left alone */
export const readAbTestMenuQueryParam = (): boolean | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const value = new URLSearchParams(window.location.search).get(
    AB_TEST_MENU_QUERY_PARAM,
  );
  if (value === 'true' || value === '1') {
    return true;
  }
  if (value === 'false' || value === '0') {
    return false;
  }
  return undefined;
};
